module.exports = __webpack_public_path__ + "static/media/rw-widgets.12f0820c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/react-widgets/fonts/rw-widgets.woff
// module id = 332
// module chunks = 0